var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.52 12.52H21.6155C21.3731 8.13952 17.8605 4.62688 13.48 4.38448V1.48C13.48 1.21504 13.265 1 13 1C12.735 1 12.52 1.21504 12.52 1.48V4.38448C8.13952 4.62688 4.62688 8.13952 4.38448 12.52H1.48C1.21504 12.52 1 12.735 1 13C1 13.265 1.21504 13.48 1.48 13.48H4.38448C4.62688 17.8605 8.13952 21.3731 12.52 21.6155V24.52C12.52 24.785 12.735 25 13 25C13.265 25 13.48 24.785 13.48 24.52V21.6155C17.8605 21.3731 21.3731 17.8605 21.6155 13.48H24.52C24.785 13.48 25 13.265 25 13C25 12.735 24.785 12.52 24.52 12.52ZM13 20.68C8.76544 20.68 5.32 17.2346 5.32 13C5.32 8.76544 8.76544 5.32 13 5.32C17.2346 5.32 20.68 8.76544 20.68 13C20.68 17.2346 17.2346 20.68 13 20.68Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 1.5,
    fill: "currentColor",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.91880cea.svg";
export { ForwardRef as ReactComponent };